const Api_URL= 'https://www.omdbapi.com/?apikey=9fa2f7f6';
// const Api_URL= 'http://www.omdbapi.com/?i=tt3896198&apikey=9fa2f7f6';


// http://www.omdbapi.com/?apikey=[yourkey]&
export default Api_URL;